/**
 * Filters an array of papers by exam, category, year, and search string.
 * @param {Array} papers - Array of normalized paper objects
 * @param {Object} filters - { examId, category, year, search }
 * @returns {Array} Filtered papers
 */
export function filterPapers(papers, { examId = '', category = 'all', year = '', search = '' }) {
  return papers.filter(paper => {
    if (examId && paper.examId !== examId) return false;
    if (category && category !== 'all' && paper.category !== category) return false;
    if (year && String(paper.year) !== String(year)) return false;
    if (search && !paper.title.toLowerCase().includes(search.toLowerCase())) return false;
    return true;
  });
}
